import React from "react";
import { Alert , Snackbar} from "@mui/material";

export default function SuccessMessage(props: any) {

    const {success, setSuccess, message} = props;
	
	return (
		<Snackbar
			open={success}
			autoHideDuration={2500}
			onClose={() => {
				setSuccess(false);
			}}
			style={{ left:'30%' }}
		>
			<Alert
				onClose={() => {
					setSuccess(false);
				}}
				severity="success"
			>
                {message}
			</Alert>
		</Snackbar>
	);
}
